import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import AddPost from "./AddPost";
import Post from "./Post";
import { useDispatch, useSelector } from "react-redux";
import { getPosts, getPostsByFollowingUsers } from "../../actions/postActions";
import LoadingPosts from "./LoadingPosts";
import { Grid } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 850,
    margin: "0 auto",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
  },

  innerContainer: {},
}));

const ListPost = ({ data }) => {
  const classes = useStyles();
  const [allPosts, setAllPosts] = useState(true);
  const dispatch = useDispatch();
  const list = useSelector((state) => state.post.list);
  const loading = useSelector((state) => state.post.loading);

  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);

  useEffect(() => {
    dispatch(allPosts ? getPosts() : getPostsByFollowingUsers());
  }, [allPosts, dispatch]);

  const handleChange = (event) => setAllPosts(event.target.checked);

  return (
    <Grid xs={12} sm={10} md={8} className={classes.container}>
      <div className={classes.innerContainer}>
        <AddPost data={data} />

        <FormControlLabel
          control={<Switch checked={allPosts} onChange={handleChange} />}
          label={allPosts ? "All posts" : "From following users"}
        />

        {loading ? (
          <LoadingPosts />
        ) : (
          list.map((el) => (
            <Grid className="my-4">
              <Post key={el._id} post={el} />
            </Grid>
          ))
        )}
      </div>
    </Grid>
  );
};

export default ListPost;
